import { Heading } from '@/components/ui/heading'
import { IconButton } from '@/components/ui/icon-button'
import LayoutHeader from '@components/LayoutHeader'
import type { Database } from '@hvf/contracts'
import { A, useLocation, useNavigate } from '@solidjs/router'
import { ArrowLeft } from 'lucide-solid'
import { type ParentProps, Show } from 'solid-js'
import Logo from 'src/core/layout/Header/Logo'
import { Container, Flex, Grid } from 'styled-system/jsx'
import { scrollbar } from 'styled-system/recipes'

export default function Layout(props: ParentProps) {
  const navigate = useNavigate()
  const location = useLocation() // <--- Added location listener

  const handleGoBack = () => {
    // If there's browser history in this tab, go back
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      // Otherwise, fallback to the root route
      // Using 'replace: true' prevents creating an extra messy history entry
      navigate('/', { replace: true })
    }
  }

  // Quick hack to hide logo on private info pages
  const isInfoPage = () => location.pathname.startsWith('/info')

  // Quick hack to extract title from the last URL segment (e.g. "privacy-policy" -> "privacy policy")
  const pageTitle = () => {
    const segment = location.pathname.split('/').filter(Boolean).pop()
    if (!segment) return 'The HVF Method'
    return segment.replace(/-/g, ' ')
  }

  return (
    <Grid gap='0' gridTemplateRows='auto 1fr'>
      <LayoutHeader
        leftContent={
          <A href='/'>
            <Flex alignItems='center' gap='2'>
              <Show when={!isInfoPage()}>
                <Logo />
              </Show>
              {/* CSS textTransform='capitalize' handles capitalizing the raw URL string */}
              <Heading textTransform='capitalize' textStyle='xl'>
                {pageTitle()}
              </Heading>
            </Flex>
          </A>
        }
        rightContent={
          <IconButton size='xs' variant='subtle' onClick={handleGoBack}>
            <ArrowLeft />
          </IconButton>
        }
      />
      <Container height='calc(var(--vh) * 100 - 64px)' w='full' class={scrollbar()} overflowY='auto'>
        {props.children}
      </Container>
    </Grid>
  )
}
